"use client"

import { BiQuestionMark, BiX, BiCheckCircle } from "react-icons/bi"
import Modal from "../modals/Modal"

export default function ConfirmAlert({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmation",
  message,
  confirmText = "Confirmer",
  cancelText = "Annuler",
  variant = "danger",
}) {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="text-center">
        <BiQuestionMark className="display-4 text-warning mb-3" />
        <p className="mb-4">{message}</p>
        <div className="d-flex gap-2 justify-content-between align-items-center">
          <button type="button" className="btn btn-secondary btn-sm d-flex align-items-center" onClick={onClose}>
            <BiX className="me-1" />{cancelText}
          </button>
          <button type="button" className={`btn btn-${variant} btn-sm d-flex align-items-center`} onClick={handleConfirm}>
            <BiCheckCircle className="me-1" />{confirmText}
          </button>
        </div>
      </div>
    </Modal>
  )
}
